import Reveal from "../../../src/components/Reveal";

export default function MissionVisionSummary() {
  return (
    <section data-testid="home-mision-vision" className="bg-white section-pad">
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <span className="gold-rule" />
            <span className="overline">Misión y Visión</span>
          </div>
          <h2 className="font-serif text-navy-900 text-3xl md:text-4xl lg:text-5xl leading-tight">
            Propósito y horizonte que guían cada intervención.
          </h2>
        </Reveal>

        <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-2 gap-8">
          <Reveal delay={100}>
            <div
              className="h-full p-8 border border-slate-200 hover:border-gold transition-colors"
              style={{ background: "#F8F9FA" }}
            >
              <span
                className="text-xs font-bold uppercase tracking-[0.22em]"
                style={{ color: "#C5A059" }}
              >
                Misión
              </span>
              <p className="mt-5 text-slate-700 leading-relaxed text-[15px]">
                Brindar soluciones jurídicas y contables integrales que garanticen seguridad normativa, eficiencia fiscal y respaldo técnico para el crecimiento empresarial.
              </p>
            </div>
          </Reveal>
          <Reveal delay={200}>
            <div
              className="h-full p-8 border border-slate-200 hover:border-gold transition-colors"
              style={{ background: "#F8F9FA" }}
            >
              <span
                className="text-xs font-bold uppercase tracking-[0.22em]"
                style={{ color: "#C5A059" }}
              >
                Visión
              </span>
              <p className="mt-5 text-slate-700 leading-relaxed text-[15px]">
                Ser una firma líder en consultoría jurídica y contable, reconocida por su impacto estratégico y respaldo técnico a nivel nacional e internacional.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}